import {Link, useLocation} from "react-router-dom";

export const AdminMenu = () => {
    const pathname = useLocation().pathname

    return (
        <div className="admin-menu-left">
            <div className="admin-menu3 mt50">
                <nav>
                    <div className={menuClass("/admin/devices", pathname)}>
                        <Link to="/admin/devices">장비(단말기정보)</Link>
                    </div>
                    <div className={menuClass("/admin/event", pathname)}>
                        <Link to="/admin/event">경로추적 정보 로그</Link>
                    </div>
                    <div className={menuClass("/admin/category", pathname)}>
                        <Link to="/admin/category">카테고리</Link>
                    </div>
                    <div className={menuClass("/admin/env", pathname)}>
                        <Link to="/admin/env">환경설정</Link>
                    </div>
                </nav>
            </div>
        </div>
    )
}

const menuClass = (menuUrl: string, currentUrl: string) => {
    return `menu-item ${currentUrl.indexOf(menuUrl) >= 0 && "active"}`
}
